import { connect } from 'react-redux';
import { CompendiumPreviewComponent } from './compendium-preview.component';

const mapStateToProps = ({ lang }) => ({
  langTags: lang.TAGS,
  langTagsPlaceholder: lang.TAGS_FORM,
});

export const CompendiumPreview = connect(mapStateToProps)(CompendiumPreviewComponent);
